import * as ngCore from '@angular/core'

import * as state from '../../../../../../../../../state'

import * as element from './element'

@ngCore.Component({
  imports: [element.Component],
  selector: 'atn-mosaic-page-grid',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /**
   * Represents the {@link state.mosaic.endUser.currentRendering.models.page.Content.Container}
   * to be rendered
   */
  public readonly containerSg =
    ngCore.input.required<state.mosaic.endUser.currentRendering.models.page.Content.Container>(
      {
        alias: 'container',
      },
    )
}
